(function() {
    "use strict";
    const root = document.querySelector(".rv-section");
      const SECTION_CART_DRAWER = "slidecart";
  const SECTION_CART_ICON   = "header";
  const CART_SECTIONS  = SECTION_CART_DRAWER + "," + SECTION_CART_ICON;
    if (!root) return;

    function readJSONAttr(name, fallback) {
        const raw = root.dataset[name];
        if (!raw) return fallback;
        try {
            return JSON.parse(raw)
        } catch {
            return fallback
        }
    }
    const LEGACY_PRODUCT_TYPE = (root.dataset.productType || "").trim(),
        PRODUCT_TITLE = root.dataset.productTitle || "",
        PRODUCT_TAGS_RAW = root.dataset.productTags || "",
        VARIANTS = readJSONAttr("variants", {});

    function decodeHtmlEntities(value) {
        if (typeof value != "string" || value.indexOf("&") === -1) return value;
        const el = document.createElement("textarea");
        return el.innerHTML = value, el.value
    }

    function deepDecodeI18n(obj) {
        if (typeof obj == "string") return decodeHtmlEntities(obj);
        if (obj && typeof obj == "object") {
            const out = Array.isArray(obj) ? [] : {};
            for (const k in obj) Object.prototype.hasOwnProperty.call(obj, k) && (out[k] = deepDecodeI18n(obj[k]));
            return out
        }
        return obj
    }
    const I18N = deepDecodeI18n(window.SC_I18N || {}),
        IS_PREVIEW = !(typeof window < "u" && window.Shopify && window.Shopify.shop);

    function tpl(str, vars) {
        return str ? str.replace(/__(\w+)__/g, (_, k) => vars && vars[k] != null ? vars[k] : "") : ""
    }

    function escapeHtml(str) {
        return String(str ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;")
    }
    const SIZE_CHARTS = {
            hoodie_regular: {
                type: "top",
                natural_fit: "regular",
                axis: "chest",
                sizes: {
                    XS: {
                        chest: 118
                    },
                    S: {
                        chest: 122
                    },
                    M: {
                        chest: 126
                    },
                    L: {
                        chest: 130
                    },
                    XL: {
                        chest: 134
                    }
                },
                ease: {
                    athletic: 25.5,
                    standard: 25,
                    corpulent: 21.5
                }
            },
            oversized_zipper: {
                type: "top",
                natural_fit: "oversize",
                axis: "chest",
                sizes: {
                    XS: {
                        chest: 128,
                        length: 58
                    },
                    S: {
                        chest: 132,
                        length: 61
                    },
                    M: {
                        chest: 136,
                        length: 64
                    },
                    L: {
                        chest: 140,
                        length: 67
                    },
                    XL: {
                        chest: 144,
                        length: 70
                    }
                },
                ease: {
                    athletic: 32.5,
                    standard: 33.5,
                    corpulent: 31.5
                }
            },
            cropped_zipper: {
                type: "top",
                natural_fit: "oversize",
                axis: "chest",
                sizes: {
                    XS: {
                        chest: 116,
                        length: 62
                    },
                    S: {
                        chest: 124,
                        length: 64
                    },
                    M: {
                        chest: 132,
                        length: 66
                    },
                    L: {
                        chest: 140,
                        length: 68
                    },
                    XL: {
                        chest: 148,
                        length: 70
                    }
                },
                ease: {
                    athletic: 28,
                    standard: 28,
                    corpulent: 28
                },
                warnings: [{
                    when: function(ctx) {
                        return ctx.height > 195
                    },
                    messageKey: "cropped_length"
                }]
            },
            boxy_tee: {
                type: "top",
                natural_fit: "oversize",
                axis: "chest",
                sizes: {
                    XS: {
                        chest: 120,
                        length: 62
                    },
                    S: {
                        chest: 124,
                        length: 64
                    },
                    M: {
                        chest: 128,
                        length: 66
                    },
                    L: {
                        chest: 132,
                        length: 68
                    },
                    XL: {
                        chest: 136,
                        length: 70
                    }
                },
                ease: {
                    athletic: 27.5,
                    standard: 27,
                    corpulent: 23.5
                }
            },
            long_sleeve: {
                type: "top",
                natural_fit: "oversize",
                axis: "chest",
                sizes: {
                    XS: {
                        chest: 116,
                        length: 64
                    },
                    S: {
                        chest: 120,
                        length: 66
                    },
                    M: {
                        chest: 124,
                        length: 68
                    },
                    L: {
                        chest: 128,
                        length: 70
                    },
                    XL: {
                        chest: 132,
                        length: 72
                    }
                },
                ease: {
                    athletic: 22,
                    standard: 25.5,
                    corpulent: 18.5
                }
            },
            jogger: {
                type: "bottom",
                natural_fit: "regular",
                axis: "hips",
                has_elastic_waist: !0,
                sizes: {
                    XS: {
                        waist: 66,
                        hips: 116
                    },
                    S: {
                        waist: 70,
                        hips: 120
                    },
                    M: {
                        waist: 74,
                        hips: 124
                    },
                    L: {
                        waist: 78,
                        hips: 128
                    },
                    XL: {
                        waist: 82,
                        hips: 132
                    }
                },
                ease: {
                    athletic: 27,
                    standard: 28,
                    corpulent: 21
                }
            },
            baggy_jogger: {
                type: "bottom",
                natural_fit: "oversize",
                axis: "hips",
                has_elastic_waist: !0,
                sizes: {
                    XS: {
                        waist: 74,
                        hips: 116
                    },
                    S: {
                        waist: 80,
                        hips: 124
                    },
                    M: {
                        waist: 86,
                        hips: 132
                    },
                    L: {
                        waist: 92,
                        hips: 140
                    },
                    XL: {
                        waist: 98,
                        hips: 148
                    }
                },
                ease: {
                    athletic: 26.5,
                    standard: 27,
                    corpulent: 26
                }
            },
            baggy_jeans: {
                type: "bottom",
                natural_fit: "oversize",
                axis: "hips",
                has_elastic_waist: !1,
                sizes: {
                    XS: {
                        waist: 76,
                        hips: 104
                    },
                    S: {
                        waist: 82,
                        hips: 108
                    },
                    M: {
                        waist: 87,
                        hips: 112
                    },
                    L: {
                        waist: 92,
                        hips: 116
                    },
                    XL: {
                        waist: 97,
                        hips: 120
                    }
                },
                ease: {
                    athletic: 14.5,
                    standard: 16,
                    corpulent: 7
                }
            },
            baggy_jeans_2: {
                type: "bottom",
                natural_fit: "oversize",
                axis: "hips",
                has_elastic_waist: !1,
                sizes: {
                    XS: {
                        waist: 76,
                        hips: 108
                    },
                    S: {
                        waist: 82,
                        hips: 112
                    },
                    M: {
                        waist: 87,
                        hips: 116
                    },
                    L: {
                        waist: 92,
                        hips: 120
                    },
                    XL: {
                        waist: 97,
                        hips: 124
                    }
                },
                ease: {
                    athletic: 14.5,
                    standard: 20,
                    corpulent: 11
                }
            }
        },
        PRODUCT_OVERRIDES = {
            jort: {
                title_match: /\bjort(s)?\b/i,
                shift: 1
            }
        };

    function applyProductOverride(size, title) {
        if (!title) return size;
        for (const key in PRODUCT_OVERRIDES) {
            const ov = PRODUCT_OVERRIDES[key];
            if (!ov.title_match.test(title)) continue;
            const shift = ov.shift || 0;
            if (shift === 0) return size;
            const idx = SIZE_ORDER.indexOf(size);
            if (idx === -1) return size;
            const newIdx = Math.max(0, Math.min(SIZE_ORDER.length - 1, idx + shift));
            return SIZE_ORDER[newIdx]
        }
        return size
    }

    function applyFitShift(size, fit) {
        const idx = SIZE_ORDER.indexOf(size);
        return idx === -1 ? size : fit === "slim" ? SIZE_ORDER[Math.max(0, idx - 1)] : fit === "oversize" ? SIZE_ORDER[Math.min(SIZE_ORDER.length - 1, idx + 1)] : size
    }
    const TITLE_DETECTORS = [{
        key: "hoodie_regular",
        test: function(t) {
            return /honey[\s-]?zipper/i.test(t)
        }
    }, {
        key: "oversized_zipper",
        test: function(t) {
            return /fur[\s-]?zip/i.test(t)
        }
    }, {
        key: "jogger",
        test: function(t) {
            return /honey[\s-]?jogger/i.test(t)
        }
    }, {
        key: "baggy_jogger",
        test: function(t) {
            return /(nylon[\s-]?jogger|jogging[\s-]?cy|baggy[\s-]?jogger)/i.test(t)
        }
    }, {
        key: "baggy_jeans_2",
        test: function(t) {
            return /cargo[\s-]?camo/i.test(t)
        }
    }, {
        key: "long_sleeve",
        test: function(t) {
            return /(long[\s-]?sleeve|longsleeve|manche[\s-]?longue)/i.test(t)
        }
    }, {
        key: "cropped_zipper",
        test: function(t) {
            return /zipper/i.test(t)
        }
    }, {
        key: "baggy_jeans",
        test: function(t) {
            return /((black|beige)[\s-]?pant|selvedge|denim|jean(s)?|cargo|\bpant(s)?\b)/i.test(t)
        }
    }, {
        key: "boxy_tee",
        test: function(t) {
            return /\b(tee|t[\s-]?shirt|tshirt)\b/i.test(t)
        }
    }, {
        key: "hoodie_regular",
        test: function(t) {
            return /(hoodie|sweat|crewneck|pullover)/i.test(t) && !/zip(per)?/i.test(t)
        }
    }];

    function detectChartFromTitle(title) {
        if (!title) return null;
        for (let i = 0; i < TITLE_DETECTORS.length; i++) {
            const det = TITLE_DETECTORS[i];
            if (det.test(title)) return det.key
        }
        return null
    }

    function detectChartFromTags(tagsRaw) {
        if (!tagsRaw) return null;
        const tags = tagsRaw.split(",").map(t => t.trim()).filter(Boolean);
        for (let i = 0; i < tags.length; i++) {
            const m = /^sizeguide:(.+)$/i.exec(tags[i]);
            if (m) {
                const key = m[1].trim();
                if (SIZE_CHARTS[key]) return key;
                window.console && console.warn && console.warn("[size-calculator] Tag sizeguide trouv\xE9 mais chart inconnu :", key)
            }
        }
        return null
    }

    function legacyProductTypeFallback(productType) {
        return productType === "jogging" ? "jogger" : productType === "hoodie_sweat" ? "hoodie_regular" : null
    }

    function resolvePageChartKey() {
        return detectChartFromTags(PRODUCT_TAGS_RAW) || detectChartFromTitle(PRODUCT_TITLE) || legacyProductTypeFallback(LEGACY_PRODUCT_TYPE) || null
    }
    const PAGE_CHART_KEY = resolvePageChartKey(),
        SIZE_ORDER = ["XS", "S", "M", "L", "XL"],
        BMI_BUMP_DOWN_THRESHOLD = 17,
        BMI_BUMP_UP_1_THRESHOLD = 28,
        BMI_BUMP_UP_2_THRESHOLD = 31,
        HEIGHT_OOR_LOW = 155,
        HEIGHT_OOR_HIGH = 200,
        BMI_OOR_LOW = 16,
        BMI_OOR_HIGH = 36,
        CONFIDENCE_FLOOR = 85,
        CONFIDENCE_BOUNDARY = 88,
        CONFIDENCE_NORMAL = 95;

    function bmiOf(h, w) {
        return w / Math.pow(h / 100, 2)
    }

    function clampSizeIdx(idx) {
        return Math.max(0, Math.min(SIZE_ORDER.length - 1, idx))
    }

    function shiftSize(size, delta) {
        const idx = SIZE_ORDER.indexOf(size);
        return idx === -1 ? size : SIZE_ORDER[clampSizeIdx(idx + delta)]
    }

    function categoryOf(chart) {
        return chart && chart.type === "bottom" ? "bottom" : "top"
    }

    function lookupBaseSize(h, w, category) {
        return category === "top" ? h < 165 ? "XS" : h < 175 ? "S" : h < 180 ? w <= 70 ? "S" : "M" : h < 185 ? "M" : h < 190 ? w <= 75 ? "M" : "L" : h < 200 ? "L" : "XL" : h < 165 ? "XS" : h < 170 ? "S" : h < 175 ? w <= 70 ? "S" : "M" : h < 185 ? "M" : h < 195 ? "L" : "XL"
    }

    function bmiBump(size, bmi, category) {
        return bmi >= BMI_BUMP_UP_2_THRESHOLD ? shiftSize(size, 2) : bmi >= BMI_BUMP_UP_1_THRESHOLD ? shiftSize(size, 1) : category === "top" && bmi <= BMI_BUMP_DOWN_THRESHOLD ? shiftSize(size, -1) : size
    }

    function isNearBoundary(h, w, category) {
        const base = lookupBaseSize(h, w, category);
        return lookupBaseSize(h, Math.max(0, w - 2), category) !== base || lookupBaseSize(h, w + 2, category) !== base
    }

    function detectOor(h, bmi) {
        return h < HEIGHT_OOR_LOW || bmi < BMI_OOR_LOW ? "below" : h > HEIGHT_OOR_HIGH || bmi > BMI_OOR_HIGH ? "above" : null
    }

    function computeConfidence(profile2, bmi, category) {
        return detectOor(profile2.height, bmi) ? CONFIDENCE_FLOOR : isNearBoundary(profile2.height, profile2.weight, category) ? CONFIDENCE_BOUNDARY : CONFIDENCE_NORMAL
    }

    function recommendItemForChart(chart, profile2, fit, ctx, item) {
        const category = categoryOf(chart),
            bmi = bmiOf(profile2.height, profile2.weight),
            baseSize = lookupBaseSize(profile2.height, profile2.weight, category),
            bumpedSize = bmiBump(baseSize, bmi, category),
            itemTitle = item && item.title ? item.title : "",
            overriddenSize = applyProductOverride(bumpedSize, itemTitle),
            finalSize = applyFitShift(overriddenSize, fit),
            oorSide = detectOor(profile2.height, bmi),
            oor = !!oorSide,
            confidence = computeConfidence(profile2, bmi, category),
            warnings = [];
        if (chart.warnings && Array.isArray(chart.warnings))
            for (const w of chart.warnings) try {
                w.when(ctx) && warnings.push(w.messageKey)
            } catch {}
        return {
            size: finalSize,
            standardSize: overriddenSize,
            algoSize: bumpedSize,
            baseSize,
            bmi,
            fit,
            category,
            oor,
            oorSide,
            confidence,
            warnings,
            waistFlag: !1,
            roundUpApplied: !1
        }
    }

    function recommend(profile2, items) {
        const ctx = {
                height: profile2.height,
                weight: profile2.weight,
                morpho: profile2.morpho,
                bmi: bmiOf(profile2.height, profile2.weight)
            },
            itemResults = {};
        for (const item of items) {
            const chart = SIZE_CHARTS[item.chartKey] || SIZE_CHARTS.hoodie_regular,
                fit = profile2.fit && profile2.fit[item.id] || "regular";
            itemResults[item.id] = recommendItemForChart(chart, profile2, fit, ctx, item)
        }
        return {
            bmi: ctx.bmi,
            items: itemResults
        }
    }
    const GIFT_CONTAINER_SELECTOR = ".moonbundle-gift-horizontal-container, .moonbundle-gift-horizontal, .moonbundle-gift";

    function selectOutsideGift(scope) {
        if (!scope) return null;
        const candidates = scope.querySelectorAll("select");
        for (let i = 0; i < candidates.length; i++) {
            const s = candidates[i];
            if (!s.closest(GIFT_CONTAINER_SELECTOR)) return s
        }
        return null
    }

    function findTitle(el, selectors) {
        if (!el) return "";
        for (const sel of selectors) {
            const found = el.querySelector(sel);
            if (found) return (found.textContent || "").trim()
        }
        return ""
    }

    function chartKeyFromTitle(title) {
        return detectChartFromTitle(title) || "hoodie_regular"
    }

    function readGiftItems(activeOption) {
        const containers = (activeOption.closest(".moonbundle-option-wrapper") || activeOption).querySelectorAll(".moonbundle-gift-horizontal-container"),
            items = [],
            genericName = I18N.gift_default_name || "T-shirt offert";
        return Array.from(containers).forEach((el, idx) => {
            el.querySelector(".moonbundle-gift-horizontal") && el.querySelector(".moonbundle-dynamic-gift-select-btn") && items.push({
                id: "mb-gift-" + idx,
                chartKey: "boxy_tee",
                title: genericName,
                select: null,
                is_gift: !0,
                no_variant_select: !0
            })
        }), items
    }

    function parseMoonbundleOption(activeOption) {
        const items = [],
            multiItems = activeOption.querySelectorAll(".moonbundle-multi-product-horizontal-layout-item");
        if (multiItems.length > 0) Array.from(multiItems).forEach((el, i) => {
            const title = findTitle(el, [".moonbundle-multi-product-title span", ".moonbundle-multi-product-title"]);
            items.push({
                id: "mb-" + i,
                chartKey: chartKeyFromTitle(title),
                title,
                select: selectOutsideGift(el),
                is_gift: !1
            })
        });
        else {
            const title = findTitle(activeOption, [".moonbundle-option-title span", ".moonbundle-option-title"]);
            items.push({
                id: "mb-0",
                chartKey: chartKeyFromTitle(title),
                title,
                select: selectOutsideGift(activeOption),
                is_gift: !1
            })
        }
        const gifts = readGiftItems(activeOption);
        for (const g of gifts) items.push(g);
        return items
    }

    function readMoonbundleItems() {
        if (!state.moonbundleBox) return null;
        const activeOption = state.moonbundleBox.querySelector(".moonbundle-option.moonbundle-option-active") || state.moonbundleBox.querySelector(".moonbundle-option-active");
        return activeOption ? parseMoonbundleOption(activeOption) : null
    }

    function findOptionForSize(selectEl, size) {
        const options = Array.from(selectEl.options).filter(o => o.value && o.value.length > 0);
        if (options.length === 0) return null;
        if (options.length === 1) return options[0];
        const upperSize = size.toUpperCase();
        return options.find(o => {
            const upper = (o.textContent || "").trim().toUpperCase();
            return upper === upperSize || upper.startsWith(upperSize + " ") || upper.startsWith(upperSize + "/") || upper.startsWith(upperSize + " /") || upper.startsWith(upperSize + "-") || upper.startsWith(upperSize + " -")
        })
    }
    const STORAGE_KEY = "sc_profile_v3",
        LEGACY_V2_KEY = "sc_profile_v2",
        LEGACY_V1_KEY = "sc_profile_v1";
    let currentStep = 1;
    const totalSteps = 4,
        state = {
            hasMoonBundle: !1,
            moonbundleBox: null,
            items: [],
            blocked: !1,
            modalOpen: !1,
            observerActive: !1,
            lastOfferSignature: null,
            bodyObserver: null,
            unitSystem: "metric"
        },
        profile = {
            height: 175,
            weight: 75,
            morpho: "standard",
            fit: {},
            unifiedFit: !0
        },
        UNIT_STORAGE_KEY = "sc_unit_pref",
        IMPERIAL_MIN_HEIGHT = 59,
        IMPERIAL_MAX_HEIGHT = 83,
        IMPERIAL_MIN_WEIGHT = 88,
        IMPERIAL_MAX_WEIGHT = 331;

    function isImperial() {
        return state.unitSystem === "imperial"
    }

    function cmToIn(cm) {
        return Math.round(cm / 2.54)
    }

    function inToCm(inches) {
        return Math.round(inches * 2.54)
    }

    function kgToLbs(kg) {
        return Math.round(kg * 2.20462)
    }

    function lbsToKg(lbs) {
        return Math.round(lbs / 2.20462)
    }

    function unitLabel(unit) {
        return isImperial() ? (unit === "cm" ? "in" : "lbs") : unit
    }

    function displayHeight(cm) {
        return isImperial() ? cmToIn(cm) : cm
    }

    function displayWeight(kg) {
        return isImperial() ? kgToLbs(kg) : kg
    }

    function readStandaloneItems() {
        return [{
            id: "main",
            chartKey: PAGE_CHART_KEY || "hoodie_regular",
            title: PRODUCT_TITLE,
            select: null,
            is_gift: !1
        }]
    }

    function refreshItems() {
        if (state.hasMoonBundle) {
            const items = readMoonbundleItems();
            if (!items || items.length === 0) {
                state.items = [], state.blocked = !0;
                return
            }
            state.items = items
        } else state.items = readStandaloneItems();
        state.blocked = !1;
        for (const item of state.items) profile.fit[item.id] || (profile.fit[item.id] = "regular")
    }
    const $ = sel => root.querySelector(sel),
        $modal = $("#rv-modal"),
        $backdrop = $("#rv-backdrop"),
        $open = $("#rv-open"),
        $close = $("#rv-close"),
        $next = $("#rv-next"),
        $back = $("#rv-back"),
        $stepLabel = $("#rv-step-label"),
        $progress = $("#rv-progress"),
        $fitHint = $("#rv-fit-hint"),
        $step3Content = $("#rv-step3-content"),
        $resultTitle = $("#rv-result-title"),
        $resultSub = $("#rv-result-sub"),
        $resultExplain = $("#rv-result-explain"),
        $bundleNote = $("#rv-bundle-note"),
        $resultCards = $("#rv-result-cards"),
        $cartError = $("#rv-cart-error"),
        $toast = $("#rv-toast"),
        $blocked = $("#rv-blocked"),
        $blockedMsg = $("#rv-blocked-message");

    function applyTriggerVisibility() {
        const hasMb = !!document.querySelector(".moonbundle-box"),
            show = !!PAGE_CHART_KEY || hasMb;
        return $open && $open.classList.toggle("rv-trigger--hidden", !show), show
    }

    function setupBodyObserverForMoonbundle() {
        state.bodyObserver || (state.bodyObserver = new MutationObserver(() => {
            document.querySelector(".moonbundle-box") && applyTriggerVisibility() && state.bodyObserver && (state.bodyObserver.disconnect(), state.bodyObserver = null)
        }), state.bodyObserver.observe(document.body, {
            childList: !0,
            subtree: !0
        }))
    }

    function openModal() {
        ensureMoonbundleDetection(), refreshItems(), loadSaved(), $modal.classList.add("is-open"), $backdrop.classList.add("is-open"), document.body.classList.add("rv-locked"), state.modalOpen = !0, state.blocked ? goToBlockedView() : goToStep(1)
    }

    function closeModal() {
        $modal.classList.remove("is-open"), $backdrop.classList.remove("is-open"), document.body.classList.remove("rv-locked"), state.modalOpen = !1
    }
    $open.addEventListener("click", openModal), $close.addEventListener("click", closeModal), $backdrop.addEventListener("click", closeModal), document.addEventListener("keydown", e => {
        e.key === "Escape" && $modal.classList.contains("is-open") && closeModal()
    });
    const $height = $("#rv-height"),
        $weight = $("#rv-weight"),
        $heightVal = $("#rv-height-value"),
        $weightVal = $("#rv-weight-value"),
        heightUnit = I18N.units && I18N.units.cm || "cm",
        weightUnit = I18N.units && I18N.units.kg || "kg";

    function syncHeight() {
        $heightVal.innerHTML = displayHeight(profile.height) + '<span class="rv-value-unit">' + escapeHtml(unitLabel(heightUnit)) + "</span>"
    }

    function syncWeight() {
        $weightVal.innerHTML = displayWeight(profile.weight) + '<span class="rv-value-unit">' + escapeHtml(unitLabel(weightUnit)) + "</span>"
    }
    $height.addEventListener("input", () => {
        profile.height = isImperial() ? inToCm(+$height.value) : +$height.value, syncHeight()
    }), $weight.addEventListener("input", () => {
        profile.weight = isImperial() ? lbsToKg(+$weight.value) : +$weight.value, syncWeight()
    });

    function setCardSelection(groupName, value) {
        const group = root.querySelector('.rv-cards[data-group="' + groupName + '"]');
        group && group.querySelectorAll(".rv-card").forEach(c => {
            c.classList.toggle("is-selected", c.dataset.value === value)
        })
    }
    root.addEventListener("click", e => {
        const card = e.target.closest(".rv-card");
        if (!card) return;
        const group = card.closest(".rv-cards");
        if (!group) return;
        const groupName = group.dataset.group,
            value = card.dataset.value;
        if (!(!groupName || !value)) {
            if (group.querySelectorAll(".rv-card").forEach(c => c.classList.remove("is-selected")), card.classList.add("is-selected"), groupName === "morpho") profile.morpho = value;
            else if (groupName === "fit-unified")
                for (const item of state.items) profile.fit[item.id] = value, setCardSelection("fit-" + item.id, value);
            else if (groupName.indexOf("fit-") === 0) {
                const itemId = groupName.substring(4);
                profile.fit[itemId] = value
            }
        }
    });

    function fitLabel(key) {
        return I18N.fit && I18N.fit[key] && I18N.fit[key].label || key
    }

    function fitDesc(key) {
        return I18N.fit && I18N.fit[key] && I18N.fit[key].desc || ""
    }

    function fitShort(key) {
        return I18N.fit && I18N.fit[key] && I18N.fit[key].short || key
    }

    function morphoShort(k) {
        return I18N.morpho && I18N.morpho[k] && I18N.morpho[k].short || k
    }

    function renderFitCardsHTML(groupName, currentValue, compact) {
        const fits = ["slim", "regular", "oversize"];
        return '<div class="' + ("rv-cards" + (compact ? " rv-cards--compact" : "")) + '" data-group="' + escapeHtml(groupName) + '">' + fits.map(fit => {
            const isSelected = fit === currentValue,
                descHtml = compact ? "" : '<div class="rv-card-desc">' + escapeHtml(fitDesc(fit)) + "</div>";
            return '<div class="rv-card' + (isSelected ? " is-selected" : "") + '" data-value="' + fit + '"><div class="rv-card-title">' + escapeHtml(fitLabel(fit)) + "</div>" + descHtml + "</div>"
        }).join("") + "</div>"
    }

    function renderToggleHTML() {
        return '<label class="rv-toggle" for="rv-unified-fit"><input type="checkbox" id="rv-unified-fit"' + (profile.unifiedFit ? " checked" : "") + '><span class="rv-toggle-track"></span><span class="rv-toggle-label">' + escapeHtml(I18N.unified_label || "") + "</span></label>"
    }

    function giftBadgeHTML() {
        return ""
    }

    function applyUnifiedFitUI(unified) {
        const u = $("#rv-fit-unified"),
            s = $("#rv-fit-split");
        u && (u.style.display = unified ? "block" : "none"), s && (s.style.display = unified ? "none" : "block")
    }

    function renderStep3() {
        if (!$step3Content) return;
        for (const item of state.items) profile.fit[item.id] || (profile.fit[item.id] = "regular");
        if (state.items.length <= 1) {
            const item = state.items[0];
            $fitHint && ($fitHint.textContent = I18N.fit_hint_single || ""), $step3Content.innerHTML = renderFitCardsHTML("fit-" + item.id, profile.fit[item.id], !1);
            return
        }
        $fitHint && ($fitHint.textContent = I18N.fit_hint_set || "");
        const firstItem = state.items[0],
            unifiedValue = profile.fit[firstItem.id] || "regular",
            splitHTML = state.items.map(item => '<div class="rv-fit-group">' + giftBadgeHTML(item) + '<div class="rv-fit-group-label">' + escapeHtml(item.title) + "</div>" + renderFitCardsHTML("fit-" + item.id, profile.fit[item.id] || "regular", !0) + "</div>").join("");
        $step3Content.innerHTML = renderToggleHTML() + '<div id="rv-fit-unified">' + renderFitCardsHTML("fit-unified", unifiedValue, !1) + '</div><div id="rv-fit-split" style="display:none">' + splitHTML + "</div>";
        const $toggle = $("#rv-unified-fit");
        $toggle && $toggle.addEventListener("change", () => {
            if (profile.unifiedFit = $toggle.checked, profile.unifiedFit) {
                const first = state.items[0],
                    v = profile.fit[first.id] || "regular";
                setCardSelection("fit-unified", v);
                for (const item of state.items) profile.fit[item.id] = v, setCardSelection("fit-" + item.id, v)
            }
            applyUnifiedFitUI(profile.unifiedFit)
        }), applyUnifiedFitUI(profile.unifiedFit)
    }

    function renderItemResultCardHTML(item, recItem) {
        const noteHtmlParts = [];
        if (recItem.oor) {
            const noteText = recItem.oorSide === "below" ? I18N.notes && I18N.notes.oor_below : I18N.notes && I18N.notes.oor_above;
            noteText && noteHtmlParts.push('<div class="rv-result-note">' + escapeHtml(noteText) + "</div>")
        } else recItem.waistFlag && I18N.notes && I18N.notes.waist && noteHtmlParts.push('<div class="rv-result-note">' + escapeHtml(I18N.notes.waist) + "</div>");
        if (recItem.warnings && recItem.warnings.length)
            for (const wk of recItem.warnings) {
                const wText = I18N.warnings && I18N.warnings[wk];
                wText && noteHtmlParts.push('<div class="rv-result-note">' + escapeHtml(wText) + "</div>")
            }
        const noteHtml = noteHtmlParts.join(""),
            fitLine = tpl(I18N.fit_prefix || "__name__", {
                name: fitShort(recItem.fit)
            }),
            confLine = tpl(I18N.confidence || "__percent__%", {
                percent: recItem.confidence
            });
        return '<div class="rv-result-card' + (item.is_gift ? " rv-result-card--gift" : "") + '">' + giftBadgeHTML(item) + '<div class="rv-result-card-head"><div class="rv-result-card-info"><div class="rv-result-item">' + escapeHtml(item.title) + '</div><div class="rv-result-fit">' + escapeHtml(fitLine) + '</div><div class="rv-result-confidence">' + escapeHtml(confLine) + '</div></div><div class="rv-result-size">' + escapeHtml(recItem.size) + "</div></div>" + noteHtml + "</div>"
    }

    function renderResult() {
        if (!$resultCards) return;
        const rec = recommend(profile, state.items);
        $resultCards.innerHTML = state.items.map(item => renderItemResultCardHTML(item, rec.items[item.id])).join("");
        const isMulti = state.items.length > 1;
        $resultTitle && ($resultTitle.textContent = (isMulti ? I18N.title_plural : I18N.title_singular) || ""), $resultExplain && ($resultExplain.textContent = (isMulti ? I18N.explain_plural : I18N.explain_singular) || ""), $bundleNote && (state.hasMoonBundle ? ($bundleNote.textContent = I18N.notes && I18N.notes.select_in_bundle || "", $bundleNote.hidden = !1) : $bundleNote.hidden = !0),             $resultSub && ($resultSub.textContent = tpl(I18N.subtitle || "__height__ __heightUnit__ \xB7 __weight__ __weightUnit__ \xB7 __morpho__", {
            height: displayHeight(profile.height),
            heightUnit: unitLabel(heightUnit),
            weightUnit: unitLabel(weightUnit),
            weight: displayWeight(profile.weight),
            morpho: morphoShort(profile.morpho)
        }))
    }

    function updateNextButton() {
        if (state.blocked) {
            $next.textContent = I18N.close || "Close", $next.dataset.role = "close";
            return
        }
        if (currentStep === totalSteps)
            if (state.hasMoonBundle) $next.textContent = I18N.view_bundle || "Voir le bundle", $next.dataset.role = "view-bundle";
            else {
                const isMulti = state.items.length > 1;
                $next.textContent = (isMulti ? I18N.add_to_cart_plural : I18N.add_to_cart_singular) || $next.textContent, $next.dataset.role = "add-to-cart"
            }
        else $next.textContent = I18N.continue || "Continue", $next.dataset.role = "continue"
    }

    function goToBlockedView() {
        state.modalOpen = !0, root.querySelectorAll(".rv-step").forEach(s => s.classList.remove("is-active")), $blocked && ($blocked.hidden = !1, $blockedMsg && ($blockedMsg.textContent = I18N.blocked && I18N.blocked.no_offer || "")), $stepLabel && ($stepLabel.textContent = ""), $progress && ($progress.style.visibility = "hidden"), $back.style.visibility = "hidden", $cartError && ($cartError.hidden = !0), $next.dataset.loading = "false", $next.disabled = !1, updateNextButton()
    }

    function goToStep(n) {
        currentStep = n, $blocked && ($blocked.hidden = !0), $progress && ($progress.style.visibility = ""), root.querySelectorAll(".rv-step").forEach(s => {
            s.classList.toggle("is-active", +s.dataset.step === n)
        }), $stepLabel && ($stepLabel.textContent = tpl(I18N.step_indicator || "Step __current__/__total__", {
            current: n,
            total: totalSteps
        })), $progress && [...$progress.children].forEach((dot, i) => {
            dot.classList.toggle("is-active", i === n - 1), dot.classList.toggle("is-done", i < n - 1)
        }), $back.style.visibility = n === 1 ? "hidden" : "visible", updateNextButton(), $cartError && ($cartError.hidden = !0), $next.dataset.loading = "false", $next.disabled = !1, n === 3 && renderStep3(), n === totalSteps && (renderResult(), saveProfile())
    }
    $next.addEventListener("click", async () => {
        const role = $next.dataset.role;
        if (role === "close") {
            closeModal();
            return
        }
        if (role === "view-bundle") {
            handleViewBundle();
            return
        }
        if (role === "add-to-cart") {
            await handleAddToCart();
            return
        }
        currentStep < totalSteps && goToStep(currentStep + 1)
    }), $back.addEventListener("click", () => {
        state.blocked || currentStep > 1 && goToStep(currentStep - 1)
    });

    function saveProfile() {
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(profile));
            localStorage.setItem(UNIT_STORAGE_KEY, state.unitSystem)
        } catch {}
    }

    function loadSaved() {
        let saved = null;
        try {
            const raw = localStorage.getItem(STORAGE_KEY);
            if (raw && (saved = JSON.parse(raw)), !saved) {
                const v2 = localStorage.getItem(LEGACY_V2_KEY),
                    v1 = localStorage.getItem(LEGACY_V1_KEY);
                if (v2) {
                    const old = JSON.parse(v2);
                    saved = {
                        height: old.height,
                        weight: old.weight,
                        morpho: old.morpho,
                        fit: typeof old.fit == "object" && old.fit !== null ? Object.assign({}, old.fit) : {
                            main: typeof old.fit == "string" ? old.fit : "regular"
                        },
                        unifiedFit: typeof old.unifiedFit == "boolean" ? old.unifiedFit : !0
                    }
                } else if (v1) {
                    const old = JSON.parse(v1);
                    saved = {
                        height: old.height,
                        weight: old.weight,
                        morpho: old.morpho,
                        fit: {
                            main: typeof old.fit == "string" ? old.fit : "regular"
                        },
                        unifiedFit: !0
                    }
                }
                saved && (localStorage.setItem(STORAGE_KEY, JSON.stringify(saved)), localStorage.removeItem(LEGACY_V2_KEY), localStorage.removeItem(LEGACY_V1_KEY))
            }
        } catch {}
        if (saved) {
            Object.assign(profile, saved), typeof profile.fit == "string" && (profile.fit = {
                main: profile.fit
            }), (!profile.fit || typeof profile.fit != "object") && (profile.fit = {}),             typeof profile.unifiedFit != "boolean" && (profile.unifiedFit = !0);
            try {
                const savedUnit = localStorage.getItem(UNIT_STORAGE_KEY);
                savedUnit === "imperial" && (state.unitSystem = "imperial")
            } catch {}
            applyUnitDisplay(), $height.value = profile.height, syncHeight(), $weight.value = profile.weight, syncWeight(), setCardSelection("morpho", profile.morpho);
            const $banner = $("#rv-saved-banner"),
                $summary = $("#rv-saved-summary");
            if ($summary) {
                const fitVals = state.items.length ? state.items.map(item => profile.fit[item.id] || "regular") : [profile.fit.main || "regular"],
                    fitSummary = fitVals.every(v => v === fitVals[0]) || state.items.length <= 1 ? fitShort(fitVals[0]) : state.items.map((item, i) => (item.title || "").toLowerCase() + " " + fitShort(fitVals[i])).join(" / ");
                $summary.textContent = displayHeight(profile.height) + unitLabel(heightUnit) + ", " + displayWeight(profile.weight) + unitLabel(weightUnit) + ", " + morphoShort(profile.morpho) + ", " + fitSummary
            }
            $banner && ($banner.style.display = "flex")
        } else {
            const $banner = $("#rv-saved-banner");
            $banner && ($banner.style.display = "none")
        }
    }
    const $resetBtn = $("#rv-saved-reset");
    $resetBtn && $resetBtn.addEventListener("click", () => {
        try {
            localStorage.removeItem(STORAGE_KEY), localStorage.removeItem(LEGACY_V2_KEY), localStorage.removeItem(LEGACY_V1_KEY)
        } catch {}
        const $banner = $("#rv-saved-banner");
        $banner && ($banner.style.display = "none")
    });
    let toastTimer = null;

    function showToast(message) {
        !$toast || !message || ($toast.textContent = message, $toast.classList.add("is-visible"), clearTimeout(toastTimer), toastTimer = setTimeout(() => {
            $toast.classList.remove("is-visible")
        }, 3500))
    }
   function showCartSkeleton() {
  if (document.querySelector(".slidecart_items .cart-skeleton")) return;

  const rows = Array.from({ length: 3 }).map(() => `
    <div class="sk-row">
      <div class="sk-block" style="width:56px;height:56px;flex-shrink:0;"></div>
      <div style="flex:1;display:flex;flex-direction:column;gap:8px;justify-content:center;">
        <div class="sk-block" style="height:12px;width:80%;"></div>
        <div class="sk-block" style="height:12px;width:40%;"></div>
      </div>
    </div>
  `).join("");

  const container = document.querySelector(".slidecart_items");
  container.insertAdjacentHTML("beforeend", `
    <div class="cart-skeleton">
      ${rows}
      <div class="sk-block" style="height:40px;width:100%;margin-top:1rem;"></div>
    </div>
  `);
}

function hideCartSkeleton() {
  const skeleton = document.querySelector(".slidecart_items .cart-skeleton");
  if (skeleton) skeleton.remove();
} 
function openDrawer(loading) {
  document.getElementById("overlay").classList.add("is-active");

  const cart = document.querySelector(".inline-cart");
  cart.classList.add("is-active");
  cart.classList.remove("cart_empty");

  document.body.classList.add("cstm_toggle_cls", "slidecart-is-open");
  document.documentElement.classList.add("slidecart-is-open");

  if (loading) {
    cart.classList.add("is-loading");
    if (document.querySelector(".alm-cart-empty")) {
      showCartSkeleton();
    }
  }
}
// Global variable to keep track of the active interval
let cartTimerInterval = null;

function initSlidecartTimer(itemCount) {
  const container = document.getElementById("slidecart-reserved-timer-container");
  const display = document.getElementById("slidecart-countdown-display");

  // Check if element exists and if the timer is enabled via theme settings
  if (!container || container.dataset.timerEnabled !== "true" || !display) {
    return;
  }

  const durationMinutes = parseInt(container.dataset.timerDuration, 10) || 10;
  const cartCount = parseInt(itemCount, 10);

  // 1. If cart is empty, clear any running timer and remove stored timestamp
  if (isNaN(cartCount) || cartCount <= 0) {
    clearInterval(cartTimerInterval);
    localStorage.removeItem("slidecart_timer_expires");
    display.textContent = "";
    return;
  }

  // 2. Retrieve or set target expiration timestamp
  let expirationTime = localStorage.getItem("slidecart_timer_expires");
  const now = new Date().getTime();

  // FIX: If no timestamp exists OR the stored timestamp has already passed, reset the timer
  if (!expirationTime || parseInt(expirationTime, 10) <= now) {
    expirationTime = now + durationMinutes * 60 * 1000;
    localStorage.setItem("slidecart_timer_expires", expirationTime);
  } else {
    expirationTime = parseInt(expirationTime, 10);
  }

  // 3. Clear existing interval loop to prevent duplicating cycles
  clearInterval(cartTimerInterval);

  // 4. Start the countdown runner
  function updateTimer() {
    const currentTime = new Date().getTime();
    const timeLeft = expirationTime - currentTime;

    if (timeLeft <= 0) {
      clearInterval(cartTimerInterval);
      localStorage.removeItem("slidecart_timer_expires");
      display.textContent = "00:00";
      return;
    }

    // Calculate minutes and seconds
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

    // Format with leading zeroes (e.g., "09:05")
    const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
    const formattedSeconds = seconds < 10 ? "0" + seconds : seconds;

    display.textContent = formattedMinutes + ":" + formattedSeconds;
  }

  updateTimer(); // Run once immediately to avoid a 1-second delay
  cartTimerInterval = setInterval(updateTimer, 1000);
}
function parseTopLevel(html) {
  // mimics $(htmlString): returns the top-level element nodes
  const template = document.createElement("template");
  template.innerHTML = html.trim();
  return Array.from(template.content.children);
}

function findInHTML(html, selector) {
  // mimics $("<div>").html(html).find(selector)
  const wrapper = document.createElement("div");
  wrapper.innerHTML = html;
  return wrapper.querySelector(selector);
}
function cartAdd(items, opts) {
  opts = opts || {};
  const payload = { items: items, sections: CART_SECTIONS };

  return fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload)
  }).then(function (response) {
    return response.json().then(function (data) {
      if (!response.ok) {
        // mimic jQuery's $.ajax rejecting with an object shaped like { responseJSON: ... }
        return Promise.reject({ responseJSON: data, status: response.status });
      }
      return data;
    });
  });
}
function cartFetch() {
  return fetch("/cart.js").then(function (response) {
    return response.json();
  });
}
function renderCartSections(response) {
  if (!response || !response.sections) return;

  const drawerHtml = response.sections[SECTION_CART_DRAWER];
  const iconHtml = response.sections[SECTION_CART_ICON];

  if (drawerHtml) {
    const topLevelNodes = parseTopLevel(drawerHtml);
    const matchedRoot = topLevelNodes.find(
      (el) => el.id === "slidingcartmain" || el.matches?.("#slidingcartmain")
    );

    const minicartData = matchedRoot
      ? matchedRoot.innerHTML
      : findInHTML(drawerHtml, "#slidingcartmain")?.innerHTML ?? null;

    if (minicartData != null) {
      const slidingCartMain = document.getElementById("slidingcartmain");
      if (slidingCartMain) slidingCartMain.innerHTML = minicartData;
    }

    // If we're on /cart, also refresh the full-page cart blocks
    if (window.location.href.indexOf("/cart") > -1) {
      const wrapper = document.createElement("div");
      wrapper.innerHTML = drawerHtml;

      const cartItemsEl = wrapper.querySelector(".c_cart_items");
      const cartTotalsEl = wrapper.querySelector(".price-subtotals");

      if (cartItemsEl != null) {
        const target = document.querySelector(".c_cart_items");
        if (target) target.innerHTML = cartItemsEl.innerHTML;
      }
      if (cartTotalsEl != null) {
        const target = document.querySelector(".price-subtotals");
        if (target) target.innerHTML = cartTotalsEl.innerHTML;
      }

      const hasLineItems = wrapper.querySelectorAll(".slidecart_items .line-item").length > 0;

      const emptyCart = document.querySelector(".c_cart_container .empty_cart");
      if (emptyCart) emptyCart.style.display = hasLineItems ? "none" : "flex";

      const subtotalMobile = document.querySelector(".c_cart_container .cart_subtotal_mobile");
      if (subtotalMobile) subtotalMobile.classList.toggle("hidden", !hasLineItems);

      const reservedText = document.querySelector(".c_cart_container .reserved_text");
      if (reservedText) reservedText.style.display = hasLineItems ? "flex" : "none";

      const cCartItems = document.querySelector(".c_cart_container .c_cart_items");
      if (cCartItems) cCartItems.style.display = hasLineItems ? "block" : "none";

      const cCartCheckout = document.querySelector(".c_cart_container .c_cart_checkout");
      if (cCartCheckout) cCartCheckout.style.display = hasLineItems ? "block" : "none";
    }
  }

  if (iconHtml) {
    const bubbleEl = findInHTML(iconHtml, ".cart-count-bubble");
    const bubbleHtml = bubbleEl ? bubbleEl.innerHTML : null;
    if (bubbleHtml != null) {
      const span = document.querySelector(".cart-count-bubble span");
      if (span) {
        span.innerHTML = response.item_count != null ? response.item_count : bubbleHtml;
      }
    }
  }

  if (response.item_count != null) {
    initSlidecartTimer(response.item_count);

    const cartCount = document.getElementById("cart-count");
    if (cartCount) cartCount.innerHTML = response.item_count;

    document.querySelectorAll(".cart-count-bubble span").forEach((el) => {
      el.innerHTML = response.item_count;
    });

    if (response.item_count > 0) {
      if (!document.querySelector(".cart-count-bubble")) {
        const headerCartIcon = document.querySelector(".header__icon--cart");
        if (headerCartIcon) {
          headerCartIcon.insertAdjacentHTML(
            "beforeend",
            "<div class='cart-count-bubble'><span aria-hidden='true'>" + response.item_count + "</span></div>"
          );
        }
      }
      document.querySelectorAll(".cart-count-bubble").forEach((el) => el.classList.remove("visually-hidden"));
    } else {
      document.querySelectorAll(".cart-count-bubble").forEach((el) => el.classList.add("visually-hidden"));
      const inlineCart = document.querySelector(".inline-cart");
      if (inlineCart) inlineCart.classList.add("cart_empty");
    }
  }

  const inlineCart = document.querySelector(".inline-cart");
  if (inlineCart) inlineCart.classList.remove("is-loading");

  const slidingCartMain = document.getElementById("slidingcartmain");
  if (slidingCartMain) slidingCartMain.classList.remove("slide_empty");

  if (response.item_count > 0) {
    document.querySelectorAll(".alm-cart-empty").forEach((el) => el.remove());
  }

  document.querySelectorAll(".product-form__submit").forEach((el) => el.classList.remove("active"));

  const cartCheckout = document.getElementById("cartCheckout");
  if (cartCheckout) cartCheckout.classList.remove("active");

  setTimeout(upsells_slick, 100);
}
function upsells_slick() {
  check_promo();
  const container = document.querySelector(".upsells_container");
  if (container != null) {
    if (container.classList.contains("slick-slider")) {
      $(container).slick("unslick");
    }

    $(container).slick({
      dots: false,
      arrows: true,
      infinite: true,
      autoplay: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: true,
      swipe: true,
      prevArrow: $(".splide__arrow--prev"),
      nextArrow: $(".splide__arrow--next")
    });
  }
}
function syncFreeProducts() {
  let staticPromise = Promise.resolve();

  // 1. Static free products check
  const freeProductForms = document.querySelectorAll(".free_products_form form");
  if (freeProductForms.length > 0) {
    const items = [];
    freeProductForms.forEach((form) => {
      const itemData = serializedFormToItems(form);
      if (Array.isArray(itemData)) {
        items.push(...itemData);
      } else if (itemData) {
        items.push(itemData);
      }
    });

    if (items.length) {
      staticPromise = cartFetch().then(function (cartData) {
        const missingItems = items.filter((newItem) => {
          const id = newItem.id || newItem.variant_id;
          return !cartData.items.some((cartItem) => cartItem.variant_id == id);
        });

        if (missingItems.length > 0) {
          return cartAdd(missingItems);
        }
        return Promise.resolve();
      });
    }
  }

  // 2. Threshold free product check
  let thresholdPromise = Promise.resolve();
  const thresholdEl = document.querySelector(".free_product_amount");

  if (thresholdEl) {
    const amountText = thresholdEl.dataset.amount || "";
    const numericPart = amountText.replace(/[^\d,.]/g, "").replace(",", ".");
    const threshold = parseFloat(numericPart) * 100;
    const variantIdInput = thresholdEl.querySelector("[name='id']");
    const variantId = variantIdInput ? variantIdInput.value : null;

    if (variantId && !isNaN(threshold)) {
      thresholdPromise = cartFetch().then(function (cartData) {
        const total = cartData.total_price;

        let itemIndex = -1;
        const existingItem = cartData.items.find((item, idx) => {
          if (item.variant_id == variantId) {
            itemIndex = idx + 1; // 1-based index for cart/change.js
            return true;
          }
          return false;
        });

        const isPresent = !!existingItem;

        if (total >= threshold && !isPresent) {
          return cartAdd([{ id: variantId, quantity: 1 }]);
        } else if (total < threshold && isPresent) {
          const lineId = existingItem.key || itemIndex;
          return cartChange(lineId, 0);
        }
        return Promise.resolve();
      });
    }
  }

  return staticPromise
    .then(() => thresholdPromise)
    .then((finalResponse) => {
      if (finalResponse && finalResponse.sections) {
        renderCartSections(finalResponse);
      } else {
        refreshDrawerOnly();
      }
    })
    .catch((err) => {
      console.error("Free product sync error:", err);
      refreshDrawerOnly();
    });
}
function refreshDrawerOnly() {
  fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ sections: CART_SECTIONS })
  })
    .then(function (response) {
      return response.json();
    })
    .then(renderCartSections)
    .catch(function (err) {
      console.error("refreshDrawerOnly error:", err);
    });
}
function serializedFormToItems(container) {
  const fields = container.querySelectorAll("input,select,textarea");
  const item = { properties: {} };
  function assign(name, value) {
    if (!name || value == null) return;
    if (name === "id") {
      item.id = value;
    } else if (name === "quantity") {
      item.quantity = parseInt(value, 10) || 1;
    } else if (name.indexOf("properties[") === 0) {
      const key = name.replace("properties[", "").replace("]", "");
      item.properties[key] = value;
    }
  }
  fields.forEach((el) => {
    const tag = el.tagName.toLowerCase();

    if (tag === "select") {
      const name = el.getAttribute("name");
      // Explicitly read the selected option's value rather than
      // trusting .value alone — this is the reliable source of truth.
      const selectedOption = el.options[el.selectedIndex];
      const value = selectedOption ? selectedOption.value : el.value;
      assign(name, value);
      return;
    }
    // input or textarea
    const type = (el.getAttribute("type") || "").toLowerCase();
    if ((type === "checkbox" || type === "radio") && !el.checked) return;
    assign(el.getAttribute("name"), el.value);
  });
  if (!item.quantity) item.quantity = 1;
  if (Object.keys(item.properties).length === 0) delete item.properties;
  if (!item.id) {
    console.warn("serializedFormToItems: no id field resolved for container:", container);
  }
  return item;
}
function addFreeProductsToCart() {
  // Check if we should add free products
  const firstForm = document.querySelector(".free_products_form form:first-child");
  const hasFreeLineItem = document.querySelector(".line-item[data_free]");

  if (!firstForm || hasFreeLineItem) {
    return Promise.resolve(); // No free products to add or already added
  }

  const freeForms = document.querySelectorAll(".free_products_form form");
  let promiseChain = Promise.resolve();

  // Process each form sequentially
  freeForms.forEach((form) => {
    promiseChain = promiseChain.then(() => {
      const formData = new FormData(form);
      return fetch("/cart/add.js", {
        method: "POST",
        body: formData
      }).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            return Promise.reject({ responseJSON: data, status: response.status });
          }
          return data;
        });
      });
    });
  });

  return promiseChain;
}
async function addToCartStandalone(rec) {
    // Helper to resolve variant ID whether key is "XL" or "XL (44)"
    const resolveVariantId = (size) => {
        if (!size) return null;
        if (VARIANTS[size]) return VARIANTS[size];
        
        // Match keys starting with the size name (e.g., "XL" matching "XL (44)")
        const matchingKey = Object.keys(VARIANTS).find(
            (k) => k === size || k.startsWith(`${size} `) || k.startsWith(`${size}(`)
        );
        return matchingKey ? VARIANTS[matchingKey] : null;
    };

    const mainSize = rec.size || (rec.items && rec.items.main && rec.items.main.size);
    const variantId = resolveVariantId(mainSize);

    if (variantId) {
        const submitBtn = document.querySelector(".product-form__submit");
        const mainForm = submitBtn ? submitBtn.closest("form") : null;

        if (mainForm) {
            const hiddenInput = mainForm.querySelector('input[name="id"].product-variant-id');
            if (hiddenInput) hiddenInput.value = variantId;

            const select = mainForm.querySelector('select[name="id"]');
            if (select) {
                select.value = variantId;
                select.dispatchEvent(new Event("change", { bubbles: true }));
            }
        }
    } else {
        console.warn("addToCartStandalone: no variant resolved for size", mainSize, rec);
    }

    // Handle upsells modal if present
    if (document.querySelector(".custom_upsells")) {
        document.querySelector(".custom_upsells").classList.add("active");
        // Note: Remove 'return;' if you still want the item added to the cart when upsells are shown.
        return; 
    }

    openDrawer(true);

    const errors = [];
    const itemsToAdd = [];

    if (state && Array.isArray(state.items)) {
        for (const item of state.items) {
            const itemConfig = rec.items && rec.items[item.id];
            const size = itemConfig ? itemConfig.size : mainSize;
            const itemVariantId = resolveVariantId(size);

            if (itemVariantId) {
                itemsToAdd.push({ id: itemVariantId, quantity: 1 });
            } else {
                errors.push((item.title || "Item") + " " + (size || "Unknown Size"));
            }
        }
    }

    if (errors.length) {
        const errorTemplate = (I18N.cart && I18N.cart.error_missing_variant) || "Missing: __list__";
        throw new Error(tpl(errorTemplate, { list: errors.join(", ") }));
    }

    try {
        const addResponse = await cartAdd(itemsToAdd);
        const cartData = await cartFetch();
        
        const mergedResponse = Object.assign({}, addResponse, {
            item_count: cartData.item_count
        });

        renderCartSections(mergedResponse);
        await syncFreeProducts();
    } catch (resp) {
        console.error("addToCartStandalone error:", resp);
        const inlineCart = document.querySelector(".inline-cart");
        if (inlineCart) inlineCart.classList.remove("is-loading");

        const desc = resp && resp.responseJSON && resp.responseJSON.description;
        alert(desc || "Could not add this item to your cart.");
    }
}
    async function addToCartViaMoonbundle(rec) {
        const errors = [],
            writes = [];
        for (const item of state.items) {
            if (item.no_variant_select) continue;
            if (!item.select) {
                errors.push((item.title || "") + " (selector missing)");
                continue
            }
            const size = rec.items[item.id].size,
                option = findOptionForSize(item.select, size);
            if (!option) {
                errors.push((item.title || "") + " " + size);
                continue
            }
            writes.push({
                select: item.select,
                value: option.value
            })
        }
        if (errors.length) throw new Error(tpl(I18N.cart && I18N.cart.error_missing_variant || "Missing: __list__", {
            list: errors.join(", ")
        }));
        for (const w of writes) w.select.value = w.value, w.select.dispatchEvent(new Event("change", {
            bubbles: !0
        }));
        await new Promise(r => setTimeout(r, 150)), closeModal();
        const btn = document.querySelector('button[name="add"].btn--add-to-cart') || document.querySelector('button[name="add"]');
        if (!btn) throw new Error(I18N.cart && I18N.cart.error_native_button || "Native add-to-cart button not found");
        btn.click()
    }

    function openCart() {
        const events = ["cart:updated", "cart:item-added", "cart:refresh", "theme:cart:open"];
        for (const name of events) document.dispatchEvent(new CustomEvent(name, {
            bubbles: !0
        })), window.dispatchEvent(new CustomEvent(name));
        setTimeout(() => {
            document.querySelector("cart-drawer[open], .cart-drawer.is-open, .drawer--cart.is-open, .cart-drawer.active") || (window.location.href = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + "cart" : "/cart")
        }, 1e3)
    }

    function handleViewBundle() {
        closeModal();
        const targetBox = document.querySelector(".moonbundle-option-active") && document.querySelector(".moonbundle-option-active").closest(".moonbundle-box") || document.querySelector(".moonbundle-box");
        targetBox && targetBox.scrollIntoView({
            behavior: "smooth",
            block: "center"
        })
    }
    async function handleAddToCart() {
        if (state.blocked) return;
        const rec = recommend(profile, state.items);
        $cartError && ($cartError.hidden = !0), $next.dataset.loading = "true", $next.disabled = !0;
        try {
            state.hasMoonBundle ? await addToCartViaMoonbundle(rec) : await addToCartStandalone(rec)
        } catch (err) {
            $cartError && ($cartError.textContent = err.message || I18N.cart && I18N.cart.error_default || "Add to cart failed", $cartError.hidden = !1)
        } finally {
            $next.dataset.loading = "false", $next.disabled = !1
        }
    }

    function computeOfferSignature(box) {
        const active = box.querySelector(".moonbundle-option.moonbundle-option-active") || box.querySelector(".moonbundle-option-active");
        if (!active) return "none";
        const multiItems = active.querySelectorAll(".moonbundle-multi-product-horizontal-layout-item");
        return multiItems.length > 0 ? "multi:" + Array.from(multiItems).map(el => findTitle(el, [".moonbundle-multi-product-title span", ".moonbundle-multi-product-title"]) || "?").join("|") : "single:" + (findTitle(active, [".moonbundle-option-title span", ".moonbundle-option-title"]) || "?")
    }

    function handleOfferChange() {
        const wasBlocked = state.blocked;
        if (refreshItems(), !!state.modalOpen) {
            if (state.blocked) {
                goToBlockedView();
                return
            }
            if (wasBlocked) {
                goToStep(1);
                return
            }
            currentStep === 3 && renderStep3(), currentStep === totalSteps && renderResult(), updateNextButton()
        }
    }

    function setupMoonbundleObserver() {
        if (state.observerActive || !state.moonbundleBox) return;
        state.observerActive = !0, state.lastOfferSignature = computeOfferSignature(state.moonbundleBox), new MutationObserver(() => {
            if (!state.moonbundleBox) return;
            const newSig = computeOfferSignature(state.moonbundleBox);
            newSig !== state.lastOfferSignature && (state.lastOfferSignature = newSig, handleOfferChange())
        }).observe(state.moonbundleBox, {
            attributes: !0,
            attributeFilter: ["class"],
            subtree: !0,
            childList: !0
        })
    }

    function ensureMoonbundleDetection() {
        if (state.moonbundleBox && !document.contains(state.moonbundleBox) && (state.moonbundleBox = null, state.hasMoonBundle = !1, state.observerActive = !1, state.lastOfferSignature = null), !state.moonbundleBox) {
            const box = document.querySelector(".moonbundle-box");
            box ? (state.moonbundleBox = box, state.hasMoonBundle = !0, setupMoonbundleObserver()) : state.hasMoonBundle = !1
        }
    }
    ensureMoonbundleDetection(), applyTriggerVisibility() || setupBodyObserverForMoonbundle(), refreshItems(), loadSaved(), applyUnitDisplay();

    function applyUnitDisplay() {
        const imperial = isImperial();
        $height.min = imperial ? IMPERIAL_MIN_HEIGHT : 150;
        $height.max = imperial ? IMPERIAL_MAX_HEIGHT : 210;
        $height.value = displayHeight(profile.height);
        $weight.min = imperial ? IMPERIAL_MIN_WEIGHT : 40;
        $weight.max = imperial ? IMPERIAL_MAX_WEIGHT : 150;
        $weight.value = displayWeight(profile.weight);
        syncHeight(), syncWeight();
        const $toggle = $("#rv-unit-toggle");
        if ($toggle) {
            $toggle.classList.toggle("is-imperial", imperial);
            $toggle.querySelectorAll(".rv-unit-toggle-label").forEach(function(label) {
                label.classList.toggle("is-active", label.dataset.unit === state.unitSystem)
            })
        }
    }

    const $unitToggle = $("#rv-unit-toggle");
    $unitToggle && $unitToggle.addEventListener("click", function() {
        state.unitSystem = isImperial() ? "metric" : "imperial";
        try {
            localStorage.setItem(UNIT_STORAGE_KEY, state.unitSystem)
        } catch {}
        applyUnitDisplay()
    })
})();